import { render, staticRenderFns } from "./CmgViewMoreRestaurants.vue?vue&type=template&id=45447f28&scoped=true&lang=pug&"
import script from "./cmg-view-more-restaurants.ts?vue&type=script&lang=ts&"
export * from "./cmg-view-more-restaurants.ts?vue&type=script&lang=ts&"
import style0 from "./CmgViewMoreRestaurants.vue?vue&type=style&index=0&id=45447f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45447f28",
  null
  
)

export default component.exports